<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="Single Table" name="first">
			<el-row>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData1" tooltip-effect="dark" @row-click="singleTable" style="width: 100%">
						<el-table-column prop="sViewName" label="Favorite"></el-table-column>
						<el-table-column prop="dTime" label="Time"></el-table-column>
						<el-table-column prop="nDownloads" label="Downloads"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange1" background layout="prev, pager, next" :total="total1"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog :title="view1.sViewName" :visible.sync="dialogVisible1" width="80%">
				<el-form label-width="160px">
					<el-form-item label="Table">{{ view1.sContent.sName }}</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view1.sContent.sSelectFilter" :key="index">
						<span class="span-label">{{ item.sColumnName }}</span>
						<label>{{ item.fuhao }}</label>
						<span class="span-label">{{ arrToString(item.value) }}</span>
					</el-form-item>
					<el-form-item label="Display Columns">
						<span class="span-label" v-for="(item,index) in view1.sContent.sSelectFieldName" :key="index">{{ zhuanhuanItem(item) }}</span>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="doDownload1">Download</el-button>
					<el-button type="primary" v-on:click="doEdit1">Edit</el-button>
					<el-button type="button" v-on:click="delete1">Delete</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view1.sViewName + 'Edit'" :visible.sync="dialogVisible11" width="80%">
				<el-form label-width="160px">
					<el-form-item label="Table">{{ view1.sContent.sName }}</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view1.sContent.sSelectFilter" :key="index">
						<el-select v-model="item.sColumnCode" placeholder="Select" clearable @change="change2(item)">
							<el-option v-for="item in options3" :key="item.sColumnCode" :label="item.sColumnName" :value="item.sColumnCode"></el-option>
						</el-select>
						<el-select v-model="item.fuhao" placeholder="Select">
							<el-option v-for="a in options4" v-if="item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1" :key="a.id" :label="a.name" :value="a.id"></el-option>
						</el-select>
						<!-- <el-input
							style="width:400px;"
							v-if="
								view2.sContent.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Event' ||
									view2.sContent.sSelectName == 'T_EDW_FACT_Evtitm_Event_All' ||
									view2.sContent.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Item'
							"
							v-model="item.value[0]"
							:placeholder="item.type"
						></el-input> -->
						<el-select v-model="item.value" style="width:400px;" multiple :multiple-limit="item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1" v-if="item.type != 'Datetime'&&view1.sContent.sSelectName!='T_EDW_FACT_Evtitm_Event_All'" filterable remote reserve-keyword :placeholder="item.type" :data-id="index" :remote-method="querySearchAsync" :loading="loading">
							<el-option v-for="item in item.options" :key="item" :label="item" :value="item"></el-option>
						</el-select>
						<el-input v-model="item.value" v-else-if="item.type != 'Datetime'&&view1.sContent.sSelectName=='T_EDW_FACT_Evtitm_Event_All'" style="width:400px;"></el-input>
						<el-date-picker v-else="item.type == 'Datetime'" style="padding:0;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" prefix-icon="xxx" v-model="item.value[0]" type="datetime" :placeholder="item.type"></el-date-picker>
						<el-button type="button" v-if="index == 0" v-on:click="addList(view1.sContent.sSelectFilter)">Add+</el-button>
						<el-button v-if="index > 0" type="button" v-on:click="deleteList(view1.sContent.sSelectFilter, index)">Delete-</el-button>
					</el-form-item>
					<el-form-item label="Columns">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						<div style="margin: 15px 0;"></div>
						<el-checkbox-group v-model="view1.sContent.sSelectFieldName" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="item in options3" :label="item.sColumnCode" :key="item.sColumnCode">{{ item.sColumnName }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="save1">Update</el-button>
					<el-button type="primary" v-on:click="save11">save as</el-button>
					<el-button type="button" v-on:click="dialogVisible11 = false">Cancel</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view1.sViewName + 'Display result'" :visible.sync="dialogVisible2" width="80%">
				<div style="font-size: 20px;" v-if="count < 1000000">
					<label>Row Count.</label>
					<span class="span-label">{{ count }}</span>
					<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'Hide' : 'Display' }}</el-button>
					<el-button v-on:click="addDownLoad">
						Download
						<span v-if="timer > 0">({{ timer }})</span>
					</el-button>
				</div>
				<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
					<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
						<el-table-column width="200" v-for="(item,index) in view1.sContent.sSelectFieldName" :key="index" :formatter="timeFormatter" :prop="item" :label="item"></el-table-column>
					</el-table>
				</div>
				<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
					<h2>
						<label>Row Count.</label>
						<span class="span-label">{{ count }}</span>
						Too much data,unable to export!
					</h2>
				</div>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane label="Multi Table" name="second">
			<el-row>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData2" tooltip-effect="dark" @row-click="multiTable" style="width: 100%">
						<el-table-column prop="sViewName" label="Favorite"></el-table-column>
						<el-table-column prop="dTime" label="Time"></el-table-column>
						<el-table-column prop="nDownloads" label="Downloads"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange2" background layout="prev, pager, next" :total="total2"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog :title="view2.sViewName" :visible.sync="dialogVisible3" width="80%">
				<el-form label-width="160px">
					<el-form-item :label="'Table' + (index + 1)" v-for="(item, index) in view2.sContent.table" :key="item.nSelectId">
						{{ item.sName }}({{ item.sBie }})
					</el-form-item>
					<el-form-item :label="'Keys' + (index + 1)" v-for="(item, index) in view2.sContent.keys" :key="index">
						<span v-for="(a, index) in item.selectKey">
							{{ item.sName1 }}({{ item.sBie1 }}).{{ stringArr(a, 0) }}={{ item.sName2 }}({{ item.sBie2 }}).{{ stringArr(a, 1) }}
							<span v-if="index != item.selectKey.length - 1">,</span>
						</span>
					</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view2.sContent.sSelectFilter" :key="index">
						<span class="span-label">{{ item.sName }}({{ item.sBie }}).{{ item.sColumnName }}</span>
						<label>{{ item.fuhao }}</label>
						<span class="span-label">{{ arrToString(item.value) }}</span>
					</el-form-item>
					<el-form-item label="Columns" v-for="(item, index) in view2.sContent.sSelectFieldName" :key="index">
						<div style="font-weight: bold;">{{ item.sNameAll + '(' + item.sBie + ')' + '.Columns' }}</div>
						<span class="span-label" v-for="a in item.value">{{ zhuanhuanItem2(item.options, a) }}</span>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="doDownload2">DownLoad</el-button>
					<el-button type="primary" v-on:click="doEdit2">Edit</el-button>
					<el-button type="button" v-on:click="delete2">Delete</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view2.sViewName + 'Edit'" :visible.sync="dialogVisible31" width="80%">
				<el-form label-width="160px">
					<el-form-item :label="'Table' + (index + 1)" v-for="(item, index) in view2.sContent.table" :key="item.nSelectId">
						{{ item.sName }}({{ item.sBie }})
					</el-form-item>
					<el-form-item :label="'Keys' + (index + 1)" v-for="(item, index) in view2.sContent.keys" :key="index">
						<span v-for="(a, index) in item.selectKey">
							{{ item.sName1 }}({{ item.sBie1 }}).{{ stringArr(a, 0) }}={{ item.sName2 }}({{ item.sBie2 }}).{{ stringArr(a, 1) }}
							<span v-if="index != item.selectKey.length - 1">,</span>
						</span>
					</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view2.sContent.sSelectFilter" :key="index">
						<el-select v-model="item.sBie" placeholder="Select" clearable @change="change4(item, index, view2.sContent.sSelectFilter)">
							<el-option v-for="a in view2.sContent.table" :key="a.sBie" :label="a.sName + '(' + a.sBie + ')'" :value="a.sBie"></el-option>
						</el-select>
						<el-select v-model="item.sColumnCode" @change="change5(item)" placeholder="Select">
							<el-option v-for="a in item.codes" :key="a.sColumnCode" :label="a.sColumnName" :value="a.sColumnCode"></el-option>
						</el-select>
						<el-select v-model="item.fuhao" placeholder="Select">
							<el-option v-for="a in options4" v-if="item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1" :key="a.id" :label="a.name" :value="a.id"></el-option>
						</el-select>
						<!-- <el-input
							style="width:400px;"
							v-if="
								item.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Event' ||
									item.sSelectName == 'T_EDW_FACT_Evtitm_Event_All' ||
									item.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Item'
							"
							v-model="item.value[0]"
							:placeholder="item.type"
						></el-input> -->
						<el-select v-model="item.value" style="width:400px;" multiple :multiple-limit="item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1" v-if="item.type != 'Datetime'&&item.sSelectName!='T_EDW_FACT_Evtitm_Event_All'" filterable remote reserve-keyword :placeholder="item.type" :data-id="index" :remote-method="querySearchAsync2" :loading="loading">
							<el-option v-for="item in item.options" :key="item" :label="item" :value="item"></el-option>
						</el-select>
						<el-input v-model="item.value" v-else-if="item.type != 'Datetime'&&item.sSelectName=='T_EDW_FACT_Evtitm_Event_All'" style="width:400px;"></el-input>
						<el-date-picker v-else="item.type == 'Datetime'" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="padding:0;" prefix-icon="xxx" v-model="item.value[0]" type="datetime" :placeholder="item.type"></el-date-picker>
						<el-button type="button" v-if="index == 0" v-on:click="addList2(view2.sContent.sSelectFilter)">Add+</el-button>
						<el-button v-if="index > 0" type="button" v-on:click="deleteList2(view2.sContent.sSelectFilter, index)">Delete-</el-button>
					</el-form-item>
					<el-form-item label="Columns" v-for="(item, index) in view2.sContent.sSelectFieldName" :key="index">
						<el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange2(item)">全选</el-checkbox>
						<div style="font-weight: bold;">{{ item.sNameAll }}({{ item.sBie }})</div>
						<el-checkbox-group v-model="item.value" @change="handleCheckedCitiesChange2">
							<el-checkbox v-for="a in item.options" :label="a.sColumnCode" :key="a.sColumnCode">{{ a.sColumnName }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="save3">Update</el-button>
					<el-button type="primary" v-on:click="save31">Save as</el-button>
					<el-button type="button" v-on:click="dialogVisible31 = false">Cancel</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view2.sViewName + 'Display result'" :visible.sync="dialogVisible4" width="80%">
				<div style="font-size: 20px;" v-if="count < 1000000">
					<label>Row Count.</label>
					<span class="span-label">{{ count }}</span>
					<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'Hide' : 'Display' }}</el-button>
					<el-button v-on:click="addDownLoad2">
						Download
						<span v-if="timer > 0">({{ timer }})</span>
					</el-button>
				</div>
				<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
					<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
						<el-table-column width="200" v-for="(item,index) in displayArr" :key="index" :formatter="timeFormatter" :prop="item" :label="item"></el-table-column>
					</el-table>
				</div>
				<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
					<h2>
						<label>Row Count.</label>
						<span class="span-label">{{ count }}</span>
						Too much data,unable to export!
					</h2>
				</div>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane label="Stored Procedure" name="third">
			<el-row>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" @row-click="sp" style="width: 100%">
						<el-table-column prop="sViewName" label="Favorite"></el-table-column>
						<el-table-column prop="dTime" label="Time"></el-table-column>
						<el-table-column prop="nDownloads" label="Downloads"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange3" background layout="prev, pager, next" :total="total3"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog :title="view3.sViewName" :visible.sync="dialogVisible5" width="80%">
				<el-form label-width="160px">
					<el-form-item label="Table">{{ view3.sContent.sName }}</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view3.sContent.sSelectFilter" :key="index">
						<span class="span-label" style="text-align: right;display: inline-block;width:300px;">{{ item.sParameterName }}</span>
						<label>=</label>
						<span class="span-label" style="max-height: 100px;overflow: auto;vertical-align: middle;">{{ arrToString(item.value) }}</span>
					</el-form-item>
					<el-form-item label="Display Columns">
						<span class="span-label" v-for="(item,index) in view3.sContent.sSelectFieldName" :key="index">{{ item.sColumnName }}</span>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="doQuery3">Query</el-button>
					<el-button type="primary" v-on:click="doEdit3">Edit</el-button>
					<el-button type="button" v-on:click="delete3">Delete</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view3.sViewName + 'Edit'" :visible.sync="dialogVisible51" width="80%">
				<el-form label-width="160px">
					<el-form-item label="Table">{{ view3.sContent.sName }}</el-form-item>
					<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in view3.sContent.sSelectFilter" :key="index">
						<span style="text-align: right;display: inline-block;width:300px;">
							<span style="color: red;" v-if="item.sRequired == 1">*</span> {{ item.sParameterName }}
						</span>
						=
						<el-select class="user-select-max-height" v-model="item.value" v-if="item.sParameterType != 'Datetime'" filterable clearable multiple :placeholder="item.sParameterType">
							<el-option v-for="item in item.options" :key="item" :label="item" :value="item"></el-option>
						</el-select>
						<el-date-picker v-else="item.sParameterType == 'Datetime'" style="padding:0;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" prefix-icon="xxx" v-model="item.value[0]" type="datetime" :placeholder="item.type"></el-date-picker>
					</el-form-item>
					<el-form-item label="Columns">
						<el-checkbox v-model="allCheck" disabled v-for="a in view3.sContent.sSelectFieldName" :key="a.sColumnCode">{{ a.sColumnName }}</el-checkbox>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-on:click="save5">Update</el-button>
					<el-button type="primary" v-on:click="save51">save as</el-button>
					<el-button type="button" v-on:click="dialogVisible51 = false">Cancel</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="view3.sViewName + 'Display result'" :visible.sync="dialogVisible6" width="80%">
				<div style="font-size: 20px;" v-if="count < 1000000">
					<label>Row Count.</label>
					<span class="span-label">{{ count }}</span>
					<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'Hide' : 'Display' }}</el-button>
					<el-button v-on:click="addDownLoad3">
						Download
						<span v-if="timer > 0">({{ timer }})</span>
					</el-button>
				</div>
				<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
					<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
						<el-table-column width="200" v-for="(item,index) in view3.sContent.sSelectFieldName" :key="index" :formatter="timeFormatter" :prop="item.sColumnCode" :label="item.sColumnName"></el-table-column>
					</el-table>
				</div>
				<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
					<h2>
						<label>Row Count.</label>
						<span class="span-label">{{ count }}</span>
						Too much data,unable to export!
					</h2>
				</div>
			</el-dialog>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import {
		getSelectViewList,
		getDynamicSQL,
		simpleDownloadExport,
		updateSelectView,
		deleteSelectView,
		addSelectView,
		getDynamicColumnList,
		addDownloadExport,
		getSelectColumnList,
		selectExColumnValueBynSelectId,
		selectColumnValueBynSelectId,
		updateFavorite,
		selectDynamic
	} from '../../api/api';
	import util from "../../api/util.js";
	export default {
		data() {
			return {
				allCheck: true,
				dialogVisible1: false,
				dialogVisible11: false,
				dialogVisible2: false,
				dialogVisible3: false,
				dialogVisible31: false,
				dialogVisible4: false,
				dialogVisible5: false,
				dialogVisible51: false,
				dialogVisible6: false,
				activeName: 'first',
				filter1: {
					nViewType: 1,
					pageSize: 10,
					currentPage: 1
				},
				filter2: {
					nViewType: 2,
					pageSize: 10,
					currentPage: 1
				},
				filter3: {
					nViewType: 3,
					pageSize: 10,
					currentPage: 1
				},
				tableData1: [],
				tableData2: [],
				tableData3: [],
				total1: 0,
				total2: 0,
				total3: 0,
				view1: {
					sContent: {
						sName: '',
						sSchema: '',
						sSchemaName: '',
						sSelectName: '',
						nSelectId: '',
						sSelectFilter: [],
						sSelectFieldName: []
					}
				},
				view2: {
					sContent: {
						sSchema: '',
						table: [{
							sName: '',
							sSchemaName: '',
							sSelectName: '',
							nSelectId: '',
							options: []
						}],
						keys: [],
						sSelectFilter: [],
						sSelectFieldName: []
					}
				},
				view3: {
					sContent: {
						sName: '',
						sSchemaName: '',
						sSelectName: '',
						nSelectId: '',
						sSelectFilter: [],
						sSelectFieldName: []
					}
				},
				tableData: [],
				showListFlag: false,
				count: 0,
				timer: 0,
				sql: {
					table: '',
					ziduan: '',
					tiaojian: ''
				},
				displayArr: [],
				isIndeterminate: false,
				options3: [],
				options4: [{
						id: 'in',
						name: '='
					},
					{
						id: '>',
						name: '>'
					},
					{
						id: '>=',
						name: '>='
					},
					{
						id: '<',
						name: '<'
					},
					{
						id: '<=',
						name: '<='
					},
					{
						id: 'not in',
						name: '!='
					}
				],
				loading: false,
				checkAll: false
			};
		},
		mounted() {
			this.getList1();
			this.getList2();
			this.getList3();
		},
		methods: {
			timeFormatter(row, column) {
				var shuju = row[column.property];
				try {
					if(shuju.indexOf('T') > -1) {
						var times = new Date(shuju);
						if(times == "Invalid Date") {
							return shuju;
						}
						return util.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
					} else {
						return shuju;
					}

				} catch(e) {
					return shuju;
				}
			},
			save5() {
				this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
					if(this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
						if(this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
							this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
						} else {
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
						}
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				}
				this.sql.tiaojian = arr.join(',');

				updateSelectView({
					nViewId: this.view3.nViewId,
					sFileName: this.view3.sViewName + '.csv',
					sSelectName: this.sql.table,
					sSelectFieldName: this.sql.ziduan,
					sSelectFilter: this.sql.tiaojian,
					sContent: JSON.stringify(this.view3.sContent),
					nViewType: 3
				}).then(res => {
					this.$message('Update Success');
					this.dialogVisible51 = false;
					this.getList3();
				});
			},
			save51() {
				this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
					if(this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
						if(this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
							this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
						} else {
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
						}
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				}
				this.sql.tiaojian = arr.join(',');

				this.$prompt('Enter file name', 'Tips', {
						confirmButtonText: 'Confirm',
						cancelButtonText: 'Cancel',
						inputPattern: /\S/,
						inputErrorMessage: 'Enter file name'
					})
					.then(({
						value
					}) => {
						addSelectView({
							sSelectName: this.sql.table,
							sSelectFieldName: this.sql.ziduan,
							sSelectFilter: this.sql.tiaojian,
							sContent: JSON.stringify(this.view3.sContent),
							sViewName: value,
							nViewType: 3
						}).then(res => {
							this.$message('Add Success');
							this.dialogVisible5 = false;
							this.dialogVisible51 = false;
							this.getList3();
						});
					})
					.catch(() => {});
			},
			delete3() {
				var _this = this;
				this.$confirm('Confirm to Delete View?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						deleteSelectView({
							nViewId: this.view3.nViewId
						}).then(res => {
							updateFavorite({
								sFavorite: 0,
								sFileName: this.view3.sViewName + '.csv'
							}).then(res => {
								this.$message('Delete success');
								this.dialogVisible5 = false;
								this.getList2();
							});
						});
					})
					.catch(() => {});
			},
			doEdit3() {
				this.dialogVisible51 = true;
			},
			doQuery3() {
				this.sql.table = this.view3.sContent.sSchemaName + '.' + this.view3.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view3.sContent.sSelectFilter.length; i++) {
					if(this.view3.sContent.sSelectFilter[i]['sRequired'] == 0) {
						if(this.view3.sContent.sSelectFilter[i]['value'].length == 0) {
							this.view3.sContent.sSelectFilter[i]['value'] = this.view3.sContent.sSelectFilter[i]['options'];
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['options'].join(',') + "'");
						} else {
							arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
						}
					} else {
						arr.push("N'" + this.view3.sContent.sSelectFilter[i]['value'].join(',') + "'");
					}
				}
				this.sql.tiaojian = arr.join(',');
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				selectDynamic({
						sSelectName: this.sql.table,
						sSelectFilter: this.sql.tiaojian,
						sSchemaName: this.view3.sContent.sSchemaName,
						currentPage: 1,
						pageSize: 100
					})
					.then(res => {
						loading.close();
						this.count = res.data.length * 1;
						if(res.data.length > 100) {
							this.tableData = res.data.slice(0, 100);
						} else {
							this.tableData = res.data;
						};

						this.dialogVisible6 = true;
					})
					.catch(res => {
						loading.close();
					});
			},
			zhuanhuanItem(item) {
				for(var i = 0; i < this.options3.length; i++) {
					if(this.options3[i]['sColumnCode'] == item) {
						return this.options3[i]['sColumnName'];
					}
				}
				return '';
			},
			zhuanhuanItem2(options3, item) {
				for(var i = 0; i < options3.length; i++) {
					if(options3[i]['sColumnCode'] == item) {
						return options3[i]['sColumnName'];
					}
				}
				return '';
			},
			delete1() {
				var _this = this;
				this.$confirm('Confirm to Delete View?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						deleteSelectView({
							nViewId: this.view1.nViewId
						}).then(res => {
							updateFavorite({
								sFavorite: 0,
								sFileName: this.view1.sViewName + '.csv'
							}).then(res => {
								this.$message('Delete success');
								this.dialogVisible1 = false;
								this.getList1();
							});
						});
					})
					.catch(() => {});
			},
			delete2() {
				var _this = this;
				this.$confirm('Confirm to Delete View?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						deleteSelectView({
							nViewId: this.view2.nViewId
						}).then(res => {
							updateFavorite({
								sFavorite: 0,
								sFileName: this.view2.sViewName + '.csv'
							}).then(res => {
								this.$message('Delete success');
								this.dialogVisible3 = false;
								this.getList2();
							});
						});
					})
					.catch(() => {});
			},
			save3() {
				var arr = [];
				var displayArr = [];
				for(var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
						arr.push(
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFieldName[i]['value'][j] +
							' as ' +
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'_' +
							this.view2.sContent.sSelectFieldName[i]['value'][j]
						);
						displayArr.push(this.view2.sContent.sSelectFieldName[i]['value'][j]);
					}
				}
				this.sql.ziduan = arr.join(',');
				var arr3 = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				for(var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
					if(this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr3.push(
							this.view2.sContent.sSelectFilter[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view2.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
							arr3.push(
								this.view2.sContent.sSelectFilter[i]['sBie'] +
								'.' +
								this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view2.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view2.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}

				var sqlDongGArr = [];
				this.view2.sContent.table.forEach(one => {
					sqlDongGArr.push(selectExColumnValueBynSelectId({
						nSelectId: one.nSelectId
					}))
				});
				Promise.all(sqlDongGArr).then(res => {
					var duoyuanarr = []
					res.forEach((one, index) => {
						one.data.forEach(two => {
							duoyuanarr.push(
								//this.view2.sContent.table[index]['sSchemaName'] + '.' + this.view2.sContent.table[index]['sSelectName'] +
								this.view2.sContent.table[index]['sBie'] +
								'.' +
								two.sColumnCode +
								' in(N' +
								two.sColumnValue +
								')'
							);
						})
					})

					arr3 = arr3.concat(duoyuanarr);
					this.sql.tiaojian = arr3.join(' and ');

					var arr = [];
					arr.push(this.view2.sContent.keys[0]['sSchema1Name'] + '.' + this.view2.sContent.keys[0]['sSelect1Name'] + ' ' + this.view2.sContent.keys[0]['sBie1']);

					for(var i = 0; i < this.view2.sContent.keys.length; i++) {
						var _arr = [];
						for(var j = 0; j < this.view2.sContent.keys[i]['selectKey'].length; j++) {
							_arr.push(
								this.view2.sContent.keys[i]['sBie1'] +
								'.' +
								this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 0) +
								'=' +
								this.view2.sContent.keys[i]['sBie2'] +
								'.' +
								this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 1)
							);
						}

						arr.push(
							this.view2.sContent.keys[i]['sSchema2Name'] +
							'.' +
							this.view2.sContent.keys[i]['sSelect2Name'] +
							' ' +
							this.view2.sContent.keys[i]['sBie2'] +
							' on ' +
							_arr.join(' and ')
						);
					}
					this.sql.table = arr.join(' left join  ');

					updateSelectView({
						nViewId: this.view2.nViewId,
						sFileName: this.view2.sViewName + '.csv',
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sContent: JSON.stringify(this.view2.sContent),
						nViewType: 2
					}).then(res => {
						this.$message('Update Success');
						this.dialogVisible3 = false;
						this.dialogVisible31 = false;
						this.getList2()
					});

				});

			},
			save31() {
				var arr = [];
				var displayArr = [];
				for(var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
						arr.push(
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFieldName[i]['value'][j] +
							' as ' +
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'_' +
							this.view2.sContent.sSelectFieldName[i]['value'][j]
						);
						displayArr.push(this.view2.sContent.sSelectFieldName[i]['value'][j]);
					}
				}
				this.sql.ziduan = arr.join(',');
				var arr3 = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				for(var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
					if(this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr3.push(
							this.view2.sContent.sSelectFilter[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view2.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
							arr3.push(
								this.view2.sContent.sSelectFilter[i]['sBie'] +
								'.' +
								this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view2.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view2.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}
				//this.sql.tiaojian = arr.join(' and ');

				var sqlDongGArr = [];
				this.view2.sContent.table.forEach(one => {
					sqlDongGArr.push(selectExColumnValueBynSelectId({
						nSelectId: one.nSelectId
					}))
				});
				Promise.all(sqlDongGArr).then(res => {
					var duoyuanarr = []
					res.forEach((one, index) => {
						one.data.forEach(two => {
							duoyuanarr.push(
								this.view2.sContent.table[index]['sBie'] +
								'.' +
								two.sColumnCode +
								' in(N' +
								two.sColumnValue +
								')'
							);
						})
					})

					arr3 = arr3.concat(duoyuanarr);
					this.sql.tiaojian = arr3.join(' and ');

					var arr = [];
					arr.push(this.view2.sContent.keys[0]['sSchema1Name'] + '.' + this.view2.sContent.keys[0]['sSelect1Name'] + ' ' + this.view2.sContent.keys[0]['sBie1']);

					for(var i = 0; i < this.view2.sContent.keys.length; i++) {
						var _arr = [];
						for(var j = 0; j < this.view2.sContent.keys[i]['selectKey'].length; j++) {
							_arr.push(
								this.view2.sContent.keys[i]['sBie1'] +
								'.' +
								this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 0) +
								'=' +
								this.view2.sContent.keys[i]['sBie2'] +
								'.' +
								this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 1)
							);
						}

						arr.push(
							this.view2.sContent.keys[i]['sSchema2Name'] +
							'.' +
							this.view2.sContent.keys[i]['sSelect2Name'] +
							' ' +
							this.view2.sContent.keys[i]['sBie2'] +
							' on ' +
							_arr.join(' and ')
						);
					}
					this.sql.table = arr.join(' left join  ');

					this.$prompt('Enter file name', 'Tips', {
							confirmButtonText: 'Confirm',
							cancelButtonText: 'Cancel',
							inputPattern: /\S/,
							inputErrorMessage: 'Enter file name'
						})
						.then(({
							value
						}) => {
							addSelectView({
								sSelectName: this.sql.table,
								sSelectFieldName: this.sql.ziduan,
								sSelectFilter: this.sql.tiaojian,
								sContent: JSON.stringify(this.view2.sContent),
								sViewName: value,
								nViewType: 2
							}).then(res => {
								this.$message('Add Success');
								this.dialogVisible3 = false;
								this.dialogVisible31 = false;
								this.getList2();
							});
						})
						.catch(() => {});
				});
			},
			save1() {
				if(this.view1.sContent.sSelectFilter.length == 1) {
					//当数组只有一个的时候 切都不存在的时候
					if(!this.view1.sContent.sSelectFilter[0]['sColumnCode'] &&
						!this.view1.sContent.sSelectFilter[0]['fuhao'] &&
						this.view1.sContent.sSelectFilter[0]['value'].length == 0
					) {
						this.view1.sContent.sSelectFilter.splice(0, 1);
						return;
					}
				}
				var flag = false;
				for(var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
					if(!this.view1.sContent.sSelectFilter[i]['sColumnCode']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(!this.view1.sContent.sSelectFilter[i]['fuhao']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(this.view1.sContent.sSelectFilter[i]['value'].length == 0) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
				}
				if(flag == true) {
					return;
				}
				if(this.view1.sContent.sSelectFieldName.length == 0) {
					this.$message.error('Please select the Columns');
					return;
				}
				this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
				}
				this.sql.ziduan = arr.join(',');
				var arr = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				for(var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
					if(this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.sql.table +
							'.' +
							this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view1.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.sql.table +
								'.' +
								this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view1.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view1.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}

				selectExColumnValueBynSelectId({
					nSelectId: this.view1.sContent.nSelectId
				}).then(res => {
					var duoyuarr = [];
					res.data.forEach(one => {
						duoyuarr.push(
							this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName +
							'.' +
							one.sColumnCode +
							' in(N' +
							one.sColumnValue +
							')'
						)
					});

					arr = arr.concat(duoyuarr);
					this.sql.tiaojian = arr.join(' and ');

					updateSelectView({
						nViewId: this.view1.nViewId,
						sFileName: this.view1.sViewName + '.csv',
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sContent: JSON.stringify(this.view1.sContent),
						nViewType: 1
					}).then(res => {
						this.$message('Update Success');
						this.dialogVisible1 = false;
						this.dialogVisible11 = false;
						this.getList1();
					});
				});

			},
			save11() {
				if(this.view1.sContent.sSelectFilter.length == 1) {
					//当数组只有一个的时候 切都不存在的时候
					if(!this.view1.sContent.sSelectFilter[0]['sColumnCode'] &&
						!this.view1.sContent.sSelectFilter[0]['fuhao'] &&
						this.view1.sContent.sSelectFilter[0]['value'].length == 0
					) {
						this.view1.sContent.sSelectFilter.splice(0, 1);
						return;
					}
				}
				var flag = false;
				for(var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
					if(!this.view1.sContent.sSelectFilter[i]['sColumnCode']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(!this.view1.sContent.sSelectFilter[i]['fuhao']) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
					if(this.view1.sContent.sSelectFilter[i]['value'].length == 0) {
						this.$message.error('Please select the Condition');
						flag = true;
						return;
					}
				}
				if(flag == true) {
					return;
				}
				if(this.view1.sContent.sSelectFieldName.length == 0) {
					this.$message.error('Please select the Columns');
					return;
				}

				this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
				}
				this.sql.ziduan = arr.join(',');
				var arr = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};

				for(var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
					if(this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.sql.table +
							'.' +
							this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view1.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.sql.table +
								'.' +
								this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view1.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view1.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}

				selectExColumnValueBynSelectId({
					nSelectId: this.view1.sContent.nSelectId
				}).then(res => {
					var duoyuarr = [];
					res.data.forEach(one => {
						duoyuarr.push(
							this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName +
							'.' +
							one.sColumnCode +
							' in(N' +
							one.sColumnValue +
							')'
						)
					});

					arr = arr.concat(duoyuarr);
					this.sql.tiaojian = arr.join(' and ');

					this.$prompt('Enter file name', 'Tips', {
							confirmButtonText: 'Confirm',
							cancelButtonText: 'Cancel',
							inputPattern: /\S/,
							inputErrorMessage: 'Enter file name'
						})
						.then(({
							value
						}) => {
							addSelectView({
								sSchema: this.view1.sSchema,
								sSelectName: this.sql.table,
								sSelectFieldName: this.sql.ziduan,
								sSelectFilter: this.sql.tiaojian,
								sContent: JSON.stringify(this.view1.sContent),
								sViewName: value,
								nViewType: 1
							}).then(res => {
								this.$message('Add Success');
								this.dialogVisible1 = false;
								this.dialogVisible11 = false;
								this.getList1();
							});
						})
						.catch(() => {});
				});

			},
			querySearchAsync2(queryString) {
				var index = 0;
				try {
					var node = window.getSelection().focusNode.parentElement;
					index = node.getAttribute('data-id');
				} catch(e) {
					//TODO handle the exception
				}
				if(!this.view2.sContent.sSelectFilter[index]['sColumnCode']) {
					this.$message.error('Please select the Condition Code');
					return;
				}
				if(queryString != '') {
					this.loading = true;
					selectColumnValueBynSelectId({
						nSelectId: this.view2.sContent.sSelectFilter[index]['nSelectId'],
						sColumnCode: this.view2.sContent.sSelectFilter[index]['sColumnCode']
					}).then(res => {
						if(res.data.length === 0) {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.view2.sContent.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.view2.sContent.sSelectFilter[index]['sSchemaName'],
								sSelectName: this.view2.sContent.sSelectFilter[index]['sSelectName'],
								pageSize: 9999
							}).then(res => {
								var arr = [];
								for(var i = 0; i < res.data.length; i++) {
									arr.push(res.data[i][this.view2.sContent.sSelectFilter[index]['sColumnCode']]);
								}
								this.loading = false;
								this.view2.sContent.sSelectFilter[index].options = arr;

							});
						} else {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.view2.sContent.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.view2.sContent.sSelectFilter[index]['sSchemaName'],
								sSelectName: this.view2.sContent.sSelectFilter[index]['sSelectName'],
								pageSize: 9999
							}).then(res2 => {
								var arr = [];
								for(var i = 0, len = res.data.length; i < len; i++) {
									for(var j = 0, len2 = res2.data.length; j < len2; j++) {
										if(res.data[i]['sColumnValue'] == res2.data[j][this.view2.sContent.sSelectFilter[index]['sColumnCode']]) {
											arr.push(res.data[i]['sColumnValue'])
										}
									}
								}
								this.loading = false;
								this.view2.sContent.sSelectFilter[index].options = arr;

							});
						}
					})
				}
			},
			querySearchAsync(queryString) {
				var index = 0;
				try {
					var node = window.getSelection().focusNode.parentElement;
					index = node.getAttribute('data-id');
				} catch(e) {
					//TODO handle the exception
				}
				if(!this.view1.sContent.sSelectFilter[index]['sColumnCode']) {
					this.$message.error('Please select the Condition Code');
					return;
				}
				if(queryString != '') {
					this.loading = true;
					selectColumnValueBynSelectId({
						nSelectId: this.view1.sContent.nSelectId,
						sColumnCode: this.view1.sContent.sSelectFilter[index]['sColumnCode']
					}).then(res => {
						if(res.data.length === 0) {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.view1.sContent.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.view1.sContent.sSchemaName,
								sSelectName: this.view1.sContent.sSelectName,
								pageSize: 9999
							}).then(res => {
								var arr = [];
								for(var i = 0; i < res.data.length; i++) {
									arr.push(res.data[i][this.view1.sContent.sSelectFilter[index]['sColumnCode']]);
								}
								this.loading = false;
								this.view1.sContent.sSelectFilter[index].options = arr;
							});
						} else {
							getDynamicColumnList({
								currentPage: 1,
								sColumnCode: this.view1.sContent.sSelectFilter[index]['sColumnCode'],
								sColumnValue: queryString,
								sSchemaName: this.view1.sContent.sSchemaName,
								sSelectName: this.view1.sContent.sSelectName,
								pageSize: 9999
							}).then(res2 => {
								var arr = [];
								for(var i = 0, len = res.data.length; i < len; i++) {
									for(var j = 0, len2 = res2.data.length; j < len2; j++) {
										if(res.data[i]['sColumnValue'] == res2.data[j][this.view1.sContent.sSelectFilter[index]['sColumnCode']]) {
											arr.push(res.data[i]['sColumnValue'])
										}
									}
								}
								this.loading = false;
								this.view1.sContent.sSelectFilter[index].options = arr;
							});
						}
					});
				}
			},
			change2(item) {
				for(var i = 0; i < this.options3.length; i++) {
					if(this.options3[i]['sColumnCode'] == item.sColumnCode) {
						item.type = this.options3[i]['sColumnType'];
					}
				}
				if(item.sColumnCode == '') {
					item.fuhao = '';
					item.value = [];
					item.options = [];
				}
			},
			change4(item, index, content) {
				if(!!item.sBie) {
					for(var i = 0; i < this.view2.sContent.table.length; i++) {
						if(this.view2.sContent.table[i]['sBie'] == item.sBie) {
							item.sName = this.view2.sContent.table[i]['sName'];
							item.sSchemaName = this.view2.sContent.table[i]['sSchemaName'];
							item.sSelectName = this.view2.sContent.table[i]['sSelectName'];
							item.nSelectId = this.view2.sContent.table[i]['nSelectId'];
						}
					}
					console.log(item);
					getSelectColumnList({
						currentPage: 1,
						nSelectId: item.nSelectId,
						pageSize: 9999
					}).then(res => {
						item.codes = res.data;
						item.fuhao = '';
						item.sColumnCode = '';
						item.value = [];
						item.options = [];
					});
				} else {
					item.fuhao = '';
					item.codes = [];
					item.sColumnCode = '';
					item.value = [];
					item.options = [];
				}
			},
			change5(item) {
				for(var i = 0; i < item.codes.length; i++) {
					if(item.codes[i]['sColumnCode'] == item.sColumnCode) {
						item.type = item.codes[i]['sColumnType'];
					}
				}
			},
			handleCheckAllChange(flag) {
				if(flag == true) {
					var arr = [];
					for(var i = 0; i < this.options3.length; i++) {
						arr.push(this.options3[i]['sColumnCode']);
					}
					this.view1.sContent.sSelectFieldName = arr;
				} else {
					this.view1.sContent.sSelectFieldName = [];
				}
				//this.view1.sContent.sSelectFieldName = flag ? this.options3 : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.options3.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.options3.length;
			},
			handleCheckAllChange2(item) {
				if(item.checkAll == false) {
					item.value = [];
				} else {
					var arr = [];
					for(var i = 0; i < item.options.length; i++) {
						arr.push(item.options[i]['sColumnCode']);
					}
					item.value = arr;
				}
				item.isIndeterminate = false;
			},
			handleCheckedCitiesChange2(value) {
				var item = null;
				for(var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.view2.sContent.sSelectFieldName[i]['options'].length; j++) {
						if(value[0] == this.view2.sContent.sSelectFieldName[i]['options'][j]['sColumnCode']) {
							item = this.view2.sContent.sSelectFieldName[i];
						}
					}
				}
				//通过value 反查。 在复制
				let checkedCount = value.length;
				if(checkedCount == 0) {
					item.checkAll = false;
					item.isIndeterminate = false;
				} else {
					item.checkAll = checkedCount === item.options.length;
					item.isIndeterminate = checkedCount > 0 && checkedCount < item.options.length;
				}
			},
			stringArr(str, index) {
				var arr = (str || '').split('=');
				try {
					return arr[index];
				} catch(e) {
					return 0;
				}
			},
			addDownLoad3() {
				if(this.timer == 0) {
					simpleDownloadExport({
						nViewId: this.view3.nViewId,
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sContent: JSON.stringify(this.view3.sContent),
						sFileName: this.view3.sViewName + '.csv',
						nType: 3
					}).then(res => {
						this.timer = 60;
						var _this = this;
						var T = setInterval(function() {
							_this.timer--;
							if(_this.timer == 1) {
								clearInterval(T);
								setTimeout(function() {
									_this.timer = 0;
								}, 1000);
							}
						}, 1000);
					});
				}
			},
			addDownLoad() {
				if(this.timer == 0) {
					simpleDownloadExport({
						nViewId: this.view1.nViewId,
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sContent: JSON.stringify(this.view1.sContent),
						sFileName: this.view1.sViewName + '.csv',
						nType: 1
					}).then(res => {
						this.timer = 60;
						var _this = this;
						var T = setInterval(function() {
							_this.timer--;
							if(_this.timer == 1) {
								clearInterval(T);
								setTimeout(function() {
									_this.timer = 0;
								}, 1000);
							}
						}, 1000);
					});
				}
			},
			addDownLoad2() {
				if(this.timer == 0) {
					simpleDownloadExport({
						nViewId: this.view2.nViewId,
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sContent: JSON.stringify(this.view2.sContent),
						sFileName: this.view2.sViewName + '.csv',
						nType: 2
					}).then(res => {
						this.timer = 60;
						var _this = this;
						var T = setInterval(function() {
							_this.timer--;
							if(_this.timer == 1) {
								clearInterval(T);
								setTimeout(function() {
									_this.timer = 0;
								}, 1000);
							}
						}, 1000);
					});
				}
			},
			doDownload2() {
				simpleDownloadExport({
					nViewId: this.view2.nViewId,
					sSchema: this.view2.sSchema,
					sSelectName: this.view2.sSelectName,
					sSelectFieldName: this.view2.sSelectFieldName,
					sSelectFilter: this.view2.sSelectFilter,
					sFileName: this.view2.sViewName + '.csv',
					sContent: JSON.stringify(this.view2.sContent),
					sFavorite: 0,
					nType: 2
				}).then(res => {
					this.$message('download success！');
				});
			},
			doDownload1() {
				simpleDownloadExport({
					nViewId: this.view1.nViewId,
					sSchema: this.view1.sSchema,
					sSelectName: this.view1.sSelectName,
					sSelectFieldName: this.view1.sSelectFieldName,
					sSelectFilter: this.view1.sSelectFilter,
					sFileName: this.view1.sViewName + '.csv',
					sContent: JSON.stringify(this.view1.sContent),
					sFavorite: 0,
					nType: 1,
				}).then(res => {
					this.$message('download success！');
				});
			},
			doQuery1() {
				this.sql.table = this.view1.sContent.sSchemaName + '.' + this.view1.sContent.sSelectName;
				var arr = [];
				for(var i = 0; i < this.view1.sContent.sSelectFieldName.length; i++) {
					arr.push(this.sql.table + '.' + this.view1.sContent.sSelectFieldName[i]);
				}
				this.sql.ziduan = arr.join(',');
				var arr = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				for(var i = 0; i < this.view1.sContent.sSelectFilter.length; i++) {
					if(this.view1.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view1.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.sql.table +
							'.' +
							this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view1.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view1.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view1.sContent.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.sql.table +
								'.' +
								this.view1.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view1.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view1.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}
				this.sql.tiaojian = arr.join(' and ');
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				getDynamicSQL({
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sSchemaName: this.view1.sContent.sSchemaName,
						currentPage: 1,
						pageSize: 100
					})
					.then(res => {
						loading.close();
						this.count = res.page.totalCount * 1;
						this.tableData = res.data;
						this.dialogVisible2 = true;
					})
					.catch(res => {
						loading.close();
					});
			},
			doEdit1() {
				// 			getSelectColumnList({
				// 				currentPage: 1,
				// 				nSelectId: this.view1.sContent.nSelectId,
				// 				pageSize: 9999
				// 			}).then(res => {
				// 				this.options3 = res.data;
				this.dialogVisible11 = true;
				// 			});
			},
			addList2(item) {
				item.push({
					nSelectId: '',
					codes: [],
					sName: '',
					sBie: '',
					sSchemaName: '',
					sSelectName: '',
					sColumnCode: '',
					fuhao: '',
					options: [],
					value: [],
					type: ''
				});
			},
			deleteList2(item, index) {
				item.splice(index, 1);
			},
			addList(item) {
				item.push({
					sColumnCode: '',
					fuhao: '',
					options: [],
					value: [],
					type: ''
				});
			},
			deleteList(item, index) {
				item.splice(index, 1);
			},
			doQuery2() {
				console.log(this.view2.sContent);
				var arr = [];
				var displayArr = [];
				for(var i = 0; i < this.view2.sContent.sSelectFieldName.length; i++) {
					for(var j = 0; j < this.view2.sContent.sSelectFieldName[i]['value'].length; j++) {
						arr.push(
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFieldName[i]['value'][j] +
							' as ' +
							this.view2.sContent.sSelectFieldName[i]['sBie'] +
							'_' +
							this.view2.sContent.sSelectFieldName[i]['value'][j]
						);
						displayArr.push(this.view2.sContent.sSelectFieldName[i]['sBie'] + '_' + this.view2.sContent.sSelectFieldName[i]['value'][j]);
					}
				}
				this.sql.ziduan = arr.join(',');
				var arr = [];
				var arrToyinhao = function(arr) {
					var _arr = [];
					for(var i = 0; i < arr.length; i++) {
						_arr.push("N'" + arr[i] + "'");
					}
					return _arr;
				};
				for(var i = 0; i < this.view2.sContent.sSelectFilter.length; i++) {
					if(this.view2.sContent.sSelectFilter[i]['fuhao'] == 'in' || this.view2.sContent.sSelectFilter[i]['fuhao'] == 'not in') {
						arr.push(
							this.view2.sContent.sSelectFilter[i]['sBie'] +
							'.' +
							this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.view2.sContent.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.view2.sContent.sSelectFilter[i]['value']).join(',') +
							')'
						);
					} else {
						for(var j = 0; j < this.view2.sContent.sSelectFilter[i]['value'].length; j++) {
							arr.push(
								this.view2.sContent.sSelectFilter[i]['sBie'] +
								'.' +
								this.view2.sContent.sSelectFilter[i]['sColumnCode'] +
								this.view2.sContent.sSelectFilter[i]['fuhao'] +
								"N'" +
								this.view2.sContent.sSelectFilter[i]['value'][j] +
								"'"
							);
						}
					}
				}
				this.sql.tiaojian = arr.join(' and ');
				var arr = [];
				arr.push(this.view2.sContent.keys[0]['sSchema1Name'] + '.' + this.view2.sContent.keys[0]['sSelect1Name'] + ' ' + this.view2.sContent.keys[0]['sBie1']);

				for(var i = 0; i < this.view2.sContent.keys.length; i++) {
					var _arr = [];
					for(var j = 0; j < this.view2.sContent.keys[i]['selectKey'].length; j++) {
						_arr.push(
							this.view2.sContent.keys[i]['sBie1'] +
							'.' +
							this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 0) +
							'=' +
							this.view2.sContent.keys[i]['sBie2'] +
							'.' +
							this.stringArr(this.view2.sContent.keys[i]['selectKey'][j], 1)
						);
					}

					arr.push(
						this.view2.sContent.keys[i]['sSchema2Name'] +
						'.' +
						this.view2.sContent.keys[i]['sSelect2Name'] +
						' ' +
						this.view2.sContent.keys[i]['sBie2'] +
						' on ' +
						_arr.join(' and ')
					);
				}
				this.sql.table = arr.join(' left join  ');

				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				getDynamicSQL({
						sSelectName: this.sql.table,
						sSelectFieldName: this.sql.ziduan,
						sSelectFilter: this.sql.tiaojian,
						sSchemaName: this.view2.sContent.sSchema,
						currentPage: 1,
						pageSize: 100
					})
					.then(res => {
						loading.close();
						this.count = res.page.totalCount * 1;
						this.tableData = res.data;
						this.displayArr = displayArr;
						this.dialogVisible4 = true;
					})
					.catch(res => {
						loading.close();
					});
			},
			doEdit2() {
				this.dialogVisible31 = true;
			},
			arrToString(arr) {
				try {
					return arr.join(',');
				} catch(e) {
					return arr;
				}
			},
			sp(row, column, event) {
				console.log(row);
				this.view3 = row;
				this.dialogVisible5 = true;
			},
			multiTable(row, column, event) {
				console.log(row);
				this.view2 = row;
				this.dialogVisible3 = true;
			},
			singleTable(row, column, event) {
				console.log(row);
				this.view1 = row;
				getSelectColumnList({
					currentPage: 1,
					nSelectId: this.view1.sContent.nSelectId,
					pageSize: 9999
				}).then(res => {
					this.options3 = res.data;
					this.dialogVisible1 = true;
				});
			},
			handleCurrentChange3(val) {
				this.filter3.currentPage = val;
				this.getList3();
			},
			handleCurrentChange2(val) {
				this.filter2.currentPage = val;
				this.getList2();
			},
			handleCurrentChange1(val) {
				this.filter1.currentPage = val;
				this.getList1();
			},
			getList1: function() {
				var param = Object.assign({}, this.filter1);
				getSelectViewList(param).then(res => {
					for(var i = 0; i < res.data.length; i++) {
						if(!!res.data[i]['sContent']) {
							res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
						} else {
							res.data[i]['sContent'] = {};
						}
					}
					this.tableData1 = res.data;
					this.total1 = res.page.totalCount * 1;
				});
			},
			getList2: function() {
				var param = Object.assign({}, this.filter2);
				getSelectViewList(param).then(res => {
					for(var i = 0; i < res.data.length; i++) {
						if(!!res.data[i]['sContent']) {
							res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
						} else {
							res.data[i]['sContent'] = {};
						}
					}
					this.tableData2 = res.data;
					this.total2 = res.page.totalCount * 1;
				});
			},
			getList3: function() {
				var param = Object.assign({}, this.filter3);
				getSelectViewList(param).then(res => {
					for(var i = 0; i < res.data.length; i++) {
						if(!!res.data[i]['sContent']) {
							res.data[i]['sContent'] = JSON.parse(res.data[i]['sContent']);
						} else {
							res.data[i]['sContent'] = {};
						}
					}
					this.tableData3 = res.data;
					this.total3 = res.page.totalCount * 1;
				});
			}
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// favorite.vue?212e8c1d